/** TypeBox schemas shared by the API (validation + OpenAPI) and the web client (types). */
import { type Static, Type } from "@sinclair/typebox";

export const MoneySchema = Type.Object(
  { micros: Type.String({ pattern: "^-?\\d+$" }), currency: Type.String({ minLength: 3, maxLength: 3 }) },
  { $id: "Money", examples: [{ micros: "12500000", currency: "USD" }] },
);

export const ProblemSchema = Type.Object(
  {
    type: Type.String(),
    title: Type.String(),
    status: Type.Integer(),
    detail: Type.Optional(Type.String()),
    errors: Type.Optional(Type.Array(Type.Object({ path: Type.String(), message: Type.String() }))),
  },
  { $id: "Problem" },
);
export type Problem = Static<typeof ProblemSchema>;

export const RangeQuery = Type.Object({
  from: Type.Optional(Type.String({ format: "date" })),
  to: Type.Optional(Type.String({ format: "date" })),
  days: Type.Optional(Type.Integer({ minimum: 1, maximum: 400 })),
  compare: Type.Optional(Type.Union([Type.Literal("previous_period"), Type.Literal("none")])),
});
export type RangeQuery = Static<typeof RangeQuery>;

export const RoleSchema = Type.Union([
  Type.Literal("viewer"),
  Type.Literal("analyst"),
  Type.Literal("manager"),
  Type.Literal("admin"),
  Type.Literal("owner"),
]);

export const MeSchema = Type.Object({
  user: Type.Object({
    id: Type.String(),
    email: Type.String(),
    name: Type.Union([Type.String(), Type.Null()]),
  }),
  workspace: Type.Object({
    id: Type.String(),
    name: Type.String(),
    /** effective: the workspace switch or the server's SAFE_MODE_FORCE */
    safeMode: Type.Boolean(),
    /** the server forces Safe mode (SAFE_MODE_FORCE); the workspace switch cannot turn it off */
    safeModeForced: Type.Boolean(),
  }),
  role: RoleSchema,
  v1Url: Type.Union([Type.String(), Type.Null()]),
});
export type Me = Static<typeof MeSchema>;

export const LoginBody = Type.Object({
  email: Type.String({ format: "email", maxLength: 255 }),
  password: Type.String({ minLength: 1, maxLength: 200 }),
});
export type LoginBody = Static<typeof LoginBody>;
